module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAAE8d1zJAAAAAXNSR0IArs4c6QAAAKRJREFUKBV9j80NgzAMhblw4sq1t3aBMkAnS7cElRHoEuGzY5tEiohk+fn9OMmQc34OfhiSY+tBAUbh6B/VAD8HqymzEwlVB7qKKphrhQyDLHyHagDucd10kSPCS0fAJoA+U1/zlAax90h1ImhSrQxNPETA1OxkgFs8Je/fqPLjyikcJX9sHyUeyAjeGquF/sWDwF9Ctdbg3ka4uDHMPWOIBurgCTK3zPSdENDoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/img/close.png
// module id = dx2p
// module chunks = 25